import {OrdersComponent} from "./orders.component";

export default OrdersComponent
